import { LinearProgress, TableBody, TableCell, TableRow } from '@mui/material';
import { groupBy } from 'lodash';
import React from 'react';

import { tableTypes } from '@/shared/components/table/duck';
import { globalTypes } from '@/shared/duck';

import { BodyRow, GroupedRow } from './components';

interface BasicTableBodyProps<DataItem> extends tableTypes.MuiTableContentProps<DataItem> {
  data: DataItem[];
  columns: tableTypes.ColumnProps<DataItem>[];
}

const UITableBody = <DataItem extends globalTypes.UIDItem>({
  data,
  columns,
  loading,
  groupRowsBy = () => '',
  itemActions,
  disableRow,
  ...props
}: BasicTableBodyProps<DataItem>) => {
  const groupedItems = React.useMemo(() => {
    return groupBy(data, groupRowsBy);
  }, [data, groupRowsBy]);

  return (
    <TableBody>
      {loading && (
        <TableRow>
          <TableCell
            sx={{
              padding: 0,
            }}
            colSpan={columns.length + (
              itemActions?.length ? 1 : 0
            ) + (
                       props.itemSelection ? 1 : 0
                     )}
          >
            <LinearProgress />
          </TableCell>
        </TableRow>
      )}

      {data.length ? (
        <>
          {Object.entries(groupedItems)
            .map((
              ([group, items]) => (
                <React.Fragment key={group}>
                  {group ? (
                    <GroupedRow
                      columns={columns}
                      group={group}
                      itemSelection={props.itemSelection}
                      itemActions={itemActions}
                    />
                  ) : null}

                  {items.map((dataItem, index) => (
                    <BodyRow<DataItem>
                      key={dataItem?.id ? (
                        dataItem.toString.length == 0 ? `index-${index}` : dataItem.id
                      ) : `item-${index}`}
                      rowKey={dataItem.id}
                      dataItem={dataItem}
                      columns={columns}
                      index={index}
                      itemActions={itemActions}
                      disableRow={disableRow}
                      {...props}
                    />
                  ))}
                </React.Fragment>
              )
            ))}
        </>
      ) : null}
    </TableBody>
  );
};

export default UITableBody;